import * as Clipboard from "expo-clipboard";
import { Alert, Linking } from "react-native";
import { isWeb } from "tamagui";

export async function openMailto(url: string) {
  try {
    const supported = await Linking.canOpenURL(url);

    if (!supported) {
      const emailAddress = url.replace(/^mailto:/, "").split("?")[0] || "";
      await Clipboard.setStringAsync(emailAddress);
      if (isWeb) {
        window.alert(
          "Can't open mail app: We didn't find a mail application on this device. The address has been copied to your clipboard instead.",
        );
      } else {
        Alert.alert(
          "Can't open mail app",
          "We didn't find a mail application on this device. The address has been copied to your clipboard instead.",
        );
      }
      return;
    }

    await Linking.openURL(url);
  } catch (err) {
    console.warn(`openMailto failed to open ${url}`, err);
  }
}
